import * as React from 'react';
import { MenuItem } from '@chakra-ui/react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';

export const AddColumnBeforeMenuItem = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <MenuItem
         onClick={() => editor.chain().focus().addColumnBefore().run()}
         icon={<FontAwesomeIcon icon={faArrowLeft} size="lg" />}
         title={_js('Add column to the left')}
         isDisabled={!editor.can().addColumnBefore()}
         iconSpacing={0}
      />
   );
};
